import { addIcons } from 'ionicons';
import {
  addOutline,
  alertCircleOutline,
  barChartOutline,
  businessOutline,
  calendarOutline,
  cameraOutline,
  checkmarkCircleOutline,
  checkmarkOutline,
  chevronExpandOutline,
  chevronForward,
  chevronForwardCircle,
  chevronForwardOutline,
  close,
  closeCircle,
  closeOutline,
  cloudUploadOutline,
  constructOutline,
  createOutline,
  ellipseOutline,
  flagOutline,
  gitNetworkOutline,
  imageOutline,
  libraryOutline,
  listCircle,
  mapOutline,
  peopleOutline,
  personCircleOutline,
  play,
  playOutline,
  qrCodeOutline,
  radioOutline,
  scaleOutline,
  searchOutline,
  shareSocial,
  shieldHalfOutline,
  sparklesOutline,
  star,
  starHalfOutline,
  starOutline,
  trashOutline,
} from 'ionicons/icons';

export function registerIonicons(): void {
  addIcons({
    addOutline,
    alertCircleOutline,
    barChartOutline,
    businessOutline,
    calendarOutline,
    cameraOutline,
    checkmarkCircleOutline,
    checkmarkOutline,
    chevronExpandOutline,
    chevronForward,
    chevronForwardCircle,
    chevronForwardOutline,
    close,
    closeCircle,
    closeOutline,
    cloudUploadOutline,
    constructOutline,
    createOutline,
    ellipseOutline,
    flagOutline,
    gitNetworkOutline,
    imageOutline,
    libraryOutline,
    listCircle,
    mapOutline,
    peopleOutline,
    personCircleOutline,
    play,
    playOutline,
    qrCodeOutline,
    radioOutline,
    scaleOutline,
    searchOutline,
    shareSocial,
    shieldHalfOutline,
    sparklesOutline,
    star,
    starHalfOutline,
    starOutline,
    trashOutline,
  });
}
